import { Reservation, ReservationStatus, ReservationType } from '@/types/residents/reservation';
import dayjs from 'dayjs';

export const reservations: Reservation[] = [
  {
    id: 'RES001',
    amenity: {
      id: 'FAC001',
      name: 'Salão do Club House'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES001',
      name: 'João Silva'
    },
    startTime: new Date('2024-03-20T18:00:00'),
    endTime: new Date('2024-03-20T20:00:00'),
    attendees: 20,
    purpose: 'Festa de aniversário para meu filho',
    notes: 'Precisarei de mesas e cadeiras configuradas'
  },
  {
    id: 'RES002',
    amenity: {
      id: 'FAC002',
      name: 'Piscina'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES002',
      name: 'Maria Silva'
    },
    startTime: new Date('2024-03-22T10:00:00'),
    endTime: new Date('2024-03-22T11:00:00'),
    attendees: 1,
    purpose: 'Nado matinal'
  },
  {
    id: 'RES003',
    amenity: {
      id: 'FAC003',
      name: 'Quadra de Tênis 1'
    },
    type: 'personal' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES003',
      name: 'Miguel Johnson'
    },
    startTime: new Date('2024-03-25T16:00:00'),
    endTime: new Date('2024-03-25T17:30:00'),
    attendees: 2,
    purpose: 'Prática de tênis'
  },
  {
    id: 'RES004',
    amenity: {
      id: 'FAC004',
      name: 'Academia'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES004',
      name: 'Sara Wilson'
    },
    startTime: new Date('2024-03-21T07:00:00'),
    endTime: new Date('2024-03-21T08:00:00'),
    attendees: 1,
    purpose: 'Treino matinal'
  },
  {
    id: 'RES005',
    amenity: {
      id: 'FAC005',
      name: 'Área de Churrasco'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES005',
      name: 'David Brown'
    },
    startTime: new Date('2024-03-23T17:00:00'),
    endTime: new Date('2024-03-23T21:00:00'),
    attendees: 15,
    purpose: 'Evento de churrasco da comunidade'
  },
  {
    id: 'RES006',
    amenity: {
      id: 'FAC006',
      name: 'Sala de Conferência'
    },
    type: 'commercial' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES006',
      name: 'Amanda Martinez'
    },
    startTime: new Date('2024-03-26T09:00:00'),
    endTime: new Date('2024-03-26T11:00:00'),
    attendees: 8,
    purpose: 'Reunião de negócios',
    notes: 'Preciso de projetor e quadro branco'
  },
  {
    id: 'RES007',
    amenity: {
      id: 'FAC007',
      name: 'Sala de Jogos'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES007',
      name: 'Christopher Lee'
    },
    startTime: new Date('2024-03-24T19:00:00'),
    endTime: new Date('2024-03-24T22:00:00'),
    attendees: 6,
    purpose: 'Noite de jogos com amigos'
  },
  {
    id: 'RES008',
    amenity: {
      id: 'FAC008',
      name: 'Sala de Cinema'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES008',
      name: 'Jennifer Garcia'
    },
    startTime: new Date('2024-03-28T20:00:00'),
    endTime: new Date('2024-03-28T23:00:00'),
    attendees: 25,
    purpose: 'Exibição de filme da comunidade',
    notes: 'Filme familiar para todas as idades'
  },
  {
    id: 'RES009',
    amenity: {
      id: 'FAC009',
      name: 'Quadra de Basquete'
    },
    type: 'personal' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES009',
      name: 'Nicole Rodriguez'
    },
    startTime: new Date('2024-03-27T15:00:00'),
    endTime: new Date('2024-03-27T17:00:00'),
    attendees: 10,
    purpose: 'Jogo de basquete'
  },
  {
    id: 'RES010',
    amenity: {
      id: 'FAC010',
      name: 'Sala de Yoga'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES010',
      name: 'Kevin White'
    },
    startTime: new Date('2024-03-29T08:00:00'),
    endTime: new Date('2024-03-29T09:00:00'),
    attendees: 1,
    purpose: 'Sessão de yoga matinal'
  }
];

export const reservationResponses = [
  {
    ...reservations[0],
    approval: {
      approvedBy: 'ADM001',
      approvedAt: dayjs('2024-03-15T11:00:00').toDate(),
      notes: 'Approved with standard conditions'
    },
    history: [
      {
        id: 'HIS001',
        timestamp: dayjs('2024-03-15T10:00:00').toDate(),
        status: 'pending' as ReservationStatus,
        details: 'Reservation request submitted',
        updatedBy: 'RES001'
      },
      {
        id: 'HIS002',
        timestamp: dayjs('2024-03-15T11:00:00').toDate(),
        status: 'approved' as ReservationStatus,
        details: 'Reservation approved by admin',
        updatedBy: 'ADM001'
      }
    ]
  }
]; 